<template>
  <v-data-table
    :value="selected"
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :item-class="getItemClass"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    :hide-default-footer="!!$slots.footer"
    show-select
    item-key="userId"
    class="user-list"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.lang`]="{ item }">
      <ag-language-text
        v-model="item.lang"
      />
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        :to="`${item.userId}`"
        append
        :disabled="!item.isSelectable"
        icon
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <template v-if="$slots.footer" v-slot:footer="{ props, on }">
      <v-row
        align="center"
        no-gutters
        class="px-2"
        style="border-top: thin solid rgba(0, 0, 0, 0.12)"
      >
        <v-col cols="auto">
          <slot name="footer" />
        </v-col>
        <v-col>
          <v-data-footer v-bind="props" style="border: none" v-on="on" />
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import Helpers from 'src/utils/helpers'
import AgLanguageText from 'src/components/common/AgLanguageText'
import { mapGetters } from 'vuex'

export default {
  name: 'UserList',
  components: {
    AgLanguageText,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('me', {
      userId: 'userId',
    }),
    headers () {
      const baseHeaders = [
        {
          text: this.$t('user.login'),
          value: 'userLogin',
        },
        {
          text: this.$t('user.roles'),
          value: 'roles',
        },
        {
          text: this.$t('user.firstName'),
          value: 'firstName',
        },
        {
          text: this.$t('user.lastName'),
          value: 'lastName',
        },
      ]

      if (this.light) {
        return baseHeaders
      }

      return [
        ...baseHeaders,
        {
          text: this.$t('general.language'),
          value: 'lang',
          filterable: true,
          align: 'center',
          width: '15%',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '15%',
        },
      ]
    },
    items () {
      return this.value.map(user => ({
        ...user,
        isSelectable: user.userId !== this.userId,
        roles: user.roles
          .map(role => this.$t(`user.roleList.${role}.name`))
          .join(', '),
      }))
    },
  },
  methods: {
    getItemClass (item) {
      return item.isSelectable || 'disabled-row'
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>

<style lang="scss" scoped>
  .user-list::v-deep .disabled-row {
    background-color: rgba(0, 0, 0, 0.1) !important;
    opacity: 0.4 !important;
  }
</style>
